<script setup>

	const url = useRequestURL()

	const { data: page } = await useAPIFetch('Musicpoint')
	const gallery = page.value.body.find(item => item.component === 'Gallery')
	const pageText = page.value.body.find(item => item.component === 'Text')

	useHeadData({
		title: page.value.meta.title,
		description: page.value.meta.description,
		author: page.value.meta.author,
		copyright: page.value.meta.copyright,
		keywords: page.value.meta.keywords,
		og: page.value.meta.og,
		url: url.href
	})
</script>

<template>
	<div>
		<div class="container">
			<h1 class="dark:text-light text-dark text-center mb-5 xl:mb-10">{{ page.attrs.title }}</h1>
			<h4 class="text-center text-cyan mb-10 xl:mb-20">Prodejna</h4>
			<div class="text-center mb-10 xl:mb-20">
				<img class="mx-auto" :src="page.attrs.image?.url" />
			</div>

			<div class="xl:grid grid-cols-12 gap-8">
				<div class="xl:col-start-3 xl:col-span-8">
					<WysiwygPerex :value="page.attrs.perex" />
					<WysiwygText :value="pageText.content" class="mb-10 xl:mb-20 wysiwyg" />
				</div> 
			</div>
		</div>

		<!-- <ClientOnly><Gallery v-if="gallery" :items="gallery.items" /></ClientOnly> -->
		<Swiper v-if="gallery" :items="gallery.items" />

		<!-- <ClientOnly><Splide /></ClientOnly> -->
	</div>
</template>

<style lang="scss" scoped>

	:deep(.wysiwyg h1), :deep(.wysiwyg h2), :deep(.wysiwyg h3), :deep(.wysiwyg h4), :deep(.wysiwyg h5) {
		color: theme('colors.cyan');
	}

	:deep(.wysiwyg p) {
		margin-bottom: 0;
	}
</style>